export default __webpack_public_path__ + "static/media/tennis-australia-logo.41f6b87e.svg";